import {SessionState} from "../Session/types";
import {ConfigApi} from "../Api/types";

class CartUtils {
    static getCartNumber(session: SessionState) {
        if (session.order_type === "ROOM_SERVICE") return session.room_number;
        if (session.order_type === "DINE_IN") return session.table_number;
        return undefined;
    }

    static isPickDateEnabled(config?: ConfigApi, session?: SessionState) {
        if (!config?.ordering.pick_date) return false;
        if (session && session.order_type && session.order_type === "DINE_IN") return false;
        return true;
    }
}

export default CartUtils;
